// extracted by mini-css-extract-plugin
export default {"container":"styles_container__byhWj","content":"styles_content__XX3fx"};